<template>
	<section class="detail-nested">
		<header>
			<i class="ion-android-arrow-back detail-header-icon" @click="closeView"></i>
			<h2>Apple Subscription History</h2>
		</header>
		<section class="apple-history-section">
			<transition name="fade" mode="out-in">
				<div v-if="loading" key="loading" class="loading">Loading...</div>
				<div v-else-if="error" key="error" class="server-data-error">{{ error }}</div>
				<div v-else-if="!subscriptionData" key="no-data" class="server-data-error">No subscription data found.</div>
				<section v-else key="data" class="blocks">
					<div class="block">
						<span class="title">Subscription Info</span>
						<ul>
							<li class="detail-row-notes">
								<div class="item-row">
									<div class="label">Correlation UUID</div>
								</div>
								{{ subscriptionData.correlationUuid }}
							</li>
							<li class="detail-row-notes">
								<div class="item-row">
									<div class="label">Created</div>
								</div>
								{{ formatDate(subscriptionData.created) }}
							</li>
						</ul>
					</div>

					<div class="block subscriptions-block" v-for="subscription in subscriptionData.subscriptions"
						:key="subscription.originalTransactionId">
						<span class="title">Subscription: {{ subscription.originalTransactionId }}</span>
						<table>
							<tr class="heading">
								<th>Event Date</th>
								<th>Event Type</th>
								<th>Subtype</th>
								<th>Transaction ID</th>
							</tr>
							<tr v-for="event in subscription.events" :key="event.id" class="no-hover">
								<td>{{ formatDateTime(event.eventDate) }}</td>
								<td>{{ formatEventName(event.eventType) }}</td>
								<td>{{ formatEventName(event.eventSubtype) || '-' }}</td>
								<td>{{ event.transactionId }}</td>
							</tr>
						</table>
					</div>
				</section>
			</transition>
		</section>
	</section>
</template>


<script>
import util from '@/util'

export default {
	name: 'user-apple-history',
	store: ['users'],
	data() {
		return {
			activeId: null,
			subscriptionData: null,
			loading: false,
			error: null
		}
	},

	computed: {
		user() {
			return this.users[this.activeId] || {
				name: null
			}
		}
	},

	created() {
		window.addEventListener('keyup', this.handleKeyup)
		this.activeId = this.$route.params.id
		this.fetchAppleSubscriptions()
	},
	destroyed() {
		window.removeEventListener('keyup', this.handleKeyup)
	},

	watch: {
		'$route'() {
			this.activeId = this.$route.params.id
			this.fetchAppleSubscriptions()
		}
	},

	methods: {
		closeView() {
			this.$emit('closeNested')
		},

		fetchAppleSubscriptions() {
			this.loading = true
			this.error = null
			this.$http.get(`/admin/users/${this.activeId}/apple-subscriptions`)
				.then((response) => {
					this.subscriptionData = response.data
				})
				.catch(error => {
					console.error('Error fetching Apple subscription history:', error)
					this.error = 'There was an issue loading Apple subscription history. Please try again.'
				})
				.finally(() => this.loading = false)
		},

		handleKeyup(e) {
			if (e.keyCode === 27 || e.key === 'Escape') this.closeView()
		},

		formatDate(date) {
			return util.formatPacificDate(date)
		},

		formatDateTime(date) {
			return util.formatDateTo(date, 'MMM D, YYYY HH:mm:ss')
		},

		formatEventName(name) {
			if (!name) return null
			return name
				.toLowerCase()
				.split('_')
				.map(word => word.charAt(0).toUpperCase() + word.slice(1))
				.join(' ')
		}
	}
}
</script>


<style scoped>
.apple-history-section {
	margin-bottom: 2em;
}

.blocks {
	display: flex;
	flex-direction: column;
}

.block {
	width: 100%;
}

.subscriptions-block {
	margin-top: 1.5em;
}

table {
	width: 100%;
	margin-top: 1em;
}

th {
	text-align: left;
}

td, th {
	padding: 8px 12px;
}
</style>
